import { useLayoutEffect, useRef } from "react";

export interface MasonryItem { id: string; img?: string; url: string; height: number; title: string; alt: string; badge?: string; }

export function MasonryGallery({ items }: { items: MasonryItem[] }) {
  const root = useRef<HTMLDivElement>(null);
  const signature = items.map((item) => item.id).join("|");
  useLayoutEffect(() => {
    const host = root.current;
    if (!host || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let frame = 0; let cancelled = false; let revert: (() => void) | undefined;
    // Wait two frames for the column layout and image ratio boxes before measuring the reveal trigger.
    frame = requestAnimationFrame(() => { frame = requestAnimationFrame(async () => {
      const [{ gsap }, { ScrollTrigger }] = await Promise.all([import("gsap"), import("gsap/ScrollTrigger")]);
      if (cancelled || !root.current) return;
      gsap.registerPlugin(ScrollTrigger);
      const ctx = gsap.context(() => gsap.fromTo(host.querySelectorAll<HTMLElement>("[data-masonry-item]"),
        { autoAlpha: 0, y: 14 },
        { autoAlpha: 1, y: 0, duration: .36, stagger: .012, ease: "power2.out", scrollTrigger: { trigger: host, start: "top 82%", once: true } }), host);
      revert = () => ctx.revert();
      const images = [...host.querySelectorAll("img")];
      if (images.some((image) => !image.complete)) Promise.all(images.map((image) => image.decode().catch(() => undefined))).then(() => { if (!cancelled) ScrollTrigger.refresh(); });
      ScrollTrigger.refresh();
    }); });
    return () => { cancelled = true; cancelAnimationFrame(frame); revert?.(); };
  }, [signature]);
  return <div className="masonry-gallery" ref={root}>{items.map((item) => <a className={`masonry-tile${item.img ? "" : " masonry-tile-preview"}`} href={item.url} key={item.id} data-masonry-item>{item.img ? <img src={item.img} alt={item.alt} loading="lazy" style={{ aspectRatio: `1 / ${item.height / 400}` }} /> : <div className="masonry-ship-placeholder" aria-label={item.alt}><span>ANACONDA</span><strong>MK II</strong><small>{item.badge}</small></div>}<span>{item.title}<i aria-hidden="true">{"\u2197"}</i></span></a>)}</div>;
}
